import { injectable } from 'tsyringe';
import { IUserActionServiceDelegate } from '../../../../shared/interfaces/user-action-service.interface';
import { LoggerService } from '../../../../shared/services/logger.service';
import { RecommendationDatastoreService } from '../../datastore-service/recommendation-datastore.service';
import { PersistentStorageService } from '../../persistent-storage-service/persistent-storage.service';
import { UserActionService } from '../../user-action.service';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  ConditionType,
  conditionType,
} from './decrators/condition-type.decorator';
import { PromotionDisplayDetails } from '../../../../shared/models/promotion-display-details.model';
import { NoRecommendationReasons } from '../no-recommendations-reasons.enums';
import { Promotion } from '../../../models/promotion.model';
import { Game } from '../../../models/game.model';
import { PromotionType } from '../../datastore-service/models/raw-promotion.model';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.Promotion)
export class ConditionPromotionCTAClicked
  implements ICondition, IUserActionServiceDelegate
{
  private readonly logger = LoggerService.getCategory(
    'ConditionPromotionCTAClicked',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly datastoreService: RecommendationDatastoreService,
    private readonly persistentLocalStorage: PersistentStorageService,
    private readonly userActionService: UserActionService,
  ) {
    this.userActionService.addListener(this);
  }

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  public shouldSkip(context: ConditionContext) {
    const { promotion } = context;

    if (promotion?.type === PromotionType.Offer) {
      return true;
    }

    return false;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { game, promotion } = context;

    const count = this.getApplicationClickedTimes(promotion, game);

    if (!count || count === 0) {
      return [true];
    }

    return [false, NoRecommendationReasons.CTAPreviouslyClicked];
  }

  // ---------------------------------------------------------------------------
  private getApplicationClickedTimes(promotion: Promotion, game: Game): number {
    const displayedApps = this.persistentLocalStorage.getDisplayedPromotionInfo(
      game,
      promotion,
    );

    if (!displayedApps) {
      return 0;
    }

    return displayedApps.CTAClicked;
  }

  // ---------------------------------------------------------------------------
  // IUserActionServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  async onUserActionCTAClicked(activePromotion: PromotionDisplayDetails) {
    const { promotionId, gameId } = activePromotion;
    this.logger.info(
      `The promotion (${gameId}, ${promotionId}) was Displayed.`,
    );

    this.persistentLocalStorage.setPromotionClicked(gameId, promotionId);
  }
}
